import { domainConfigs } from '@/config/domains';
import { useEffect, useState } from 'react';

const HOTEL_SCRIPT = '/hotel-remote/hotel-app.es.js';

/** Dynamically loads the hotel web component bundle once and tracks readiness. */
function useHotelWC() {
  const [ready, setReady] = useState(() => !!customElements.get('hotel-app'));
  const [error, setError] = useState(false);

  useEffect(() => {
    if (ready || error) return;

    // Inject the script only once across navigations
    if (!document.querySelector(`script[src="${HOTEL_SCRIPT}"]`)) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = HOTEL_SCRIPT;
      script.onerror = () => setError(true);
      document.head.appendChild(script);
    }

    // Wait for <hotel-app> custom element to be registered
    customElements
      .whenDefined('hotel-app')
      .then(() => setReady(true))
      .catch(() => setError(true));
  }, [ready, error]);

  return { ready, error };
}

export default function HotelPage() {
  const { ready, error } = useHotelWC();

  if (error) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-4 text-center">
        <p className="font-semibold text-destructive">Hotel module not available</p>
        <p className="text-sm text-muted-foreground">Build the hotel bundle first:</p>
        <code className="rounded bg-muted px-3 py-1.5 font-mono text-xs">
          cd hotel-fe &amp;&amp; pnpm build:wc:b2c
        </code>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-9 w-9 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <hotel-app
      style={{ display: 'block', minHeight: 'calc(100vh - 56px)' }}
      auth-token={sessionStorage.getItem('token') ?? ''}
      user-id={sessionStorage.getItem('userId') ?? ''}
      corporate-name={sessionStorage.getItem('corporateName') ?? ''}
      backend-url={`${domainConfigs[window.location.hostname]?.apiUrl ?? ''}`}
    />
  );
}
